import type { BaseTheme } from '../types/BaseTheme';
import colors from './colors';
import ems from './ems';
import radii from './radii';
import sizes from './sizes';
import space from './space';
import transitionDuration from './transitionDuration';
import transitionTimingFunction from './transitionTimingFunction';

const baseTheme: BaseTheme = {
  colors,
  ems,
  radii,
  space,
  sizes,
  transitionDuration,
  transitionTimingFunction,
  components: {
    borderBox: {
      common: {
        borderStyle: 'solid',
      },
      variants: {
        default: {
          borderColor: 'border.primary',
        },
      },
    },
    button: {
      common: {
        outline: 'none',
        '-webkit-tap-highlight-color': 'rgba(0, 0, 0, 0)',
        display: 'inline-flex',
        alignItems: 'center',
        userSelect: 'none',
        lineHeight: 'tight',
        transitionDuration: 'normal',
        transitionTimingFunction: 'easeInOut',
        transitionProperty: 'background-color, color, opacity',
      },
    },
  },
};

export default baseTheme;
